import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LandingPageBlock, ImageAsset } from '../../../models/cms-models';

@Component({
  selector: 'cms-landing-page-image-block-editor',
  imports: [CommonModule, FormsModule],
  templateUrl: './landing-page-image-block-editor.html',
  styleUrl: './landing-page-block-editor-fields.css',
})
export class LandingPageImageBlockEditorComponent {
  @Input({ required: true }) block!: LandingPageBlock;
  @Input() availableImages: ImageAsset[] = [];
  @Output() blockChange = new EventEmitter<Partial<LandingPageBlock>>();

  get selectedImage(): ImageAsset | null {
    return this.availableImages.find((image) => image.id === this.block.imageId) ?? null;
  }

  updateImageId(value: string): void {
    this.blockChange.emit({ imageId: value || null });
  }

  updateImageAltOverride(value: string): void {
    this.blockChange.emit({ imageAltOverride: value || null });
  }

  updateImageCaptionOverride(value: string): void {
    this.blockChange.emit({ imageCaptionOverride: value || null });
  }
}
